<div itemscope itemtype="https://schema.org/Organization">
  <p>
    <span itemprop="legalName">AKlor Software, LLC </span>
    <span>was founded in 2014 to provide computer software, hardware, and website development for the </span>
    <span itemprop="location" itemscope itemtype="https://schema.org/PostalAddress">
      <span itemprop="addressLocality">Springfield </span>
      <span>, </span>
      <span itemprop="addressRegion">MO </span>
      <span>area.</span>
    </span>
  </p>
</div>